/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignBusinessEntityRequest } from '../models/AssignBusinessEntityRequest';
import type { CaseInvestigationStatus } from '../models/CaseInvestigationStatus';
import type { CaseNoticeType } from '../models/CaseNoticeType';
import type { CaseSection } from '../models/CaseSection';
import type { CaseSortBy } from '../models/CaseSortBy';
import type { CaseStatus } from '../models/CaseStatus';
import type { CertificateStatus } from '../models/CertificateStatus';
import type { CreateCaseNoteRequest } from '../models/CreateCaseNoteRequest';
import type { CreateCaseNoteResponse } from '../models/CreateCaseNoteResponse';
import type { DeleteCaseRequest } from '../models/DeleteCaseRequest';
import type { ExportFormat } from '../models/ExportFormat';
import type { GenerateCaseLettersRequest } from '../models/GenerateCaseLettersRequest';
import type { GetCaseHistoryResponse } from '../models/GetCaseHistoryResponse';
import type { GetCaseResponse } from '../models/GetCaseResponse';
import type { ListCaseAffiliationsResponse } from '../models/ListCaseAffiliationsResponse';
import type { ListCaseComplainantTypesResponse } from '../models/ListCaseComplainantTypesResponse';
import type { ListCaseDeleteReasonsResponse } from '../models/ListCaseDeleteReasonsResponse';
import type { ListCaseLetterTypesResponse } from '../models/ListCaseLetterTypesResponse';
import type { ListCaseNotesResponse } from '../models/ListCaseNotesResponse';
import type { ListCasesResponse } from '../models/ListCasesResponse';
import type { ListCaseTopicsResponse } from '../models/ListCaseTopicsResponse';
import type { ListCaseTypesResponse } from '../models/ListCaseTypesResponse';
import type { ListCaseViolationsResponse } from '../models/ListCaseViolationsResponse';
import type { Region } from '../models/Region';
import type { SearchOriginalCaseCandidatesResponse } from '../models/SearchOriginalCaseCandidatesResponse';
import type { SortDirection } from '../models/SortDirection';
import type { StoredDocument } from '../models/StoredDocument';
import type { UpdateCaseInvestigationRequest } from '../models/UpdateCaseInvestigationRequest';
import type { UpdateCaseNoteRequest } from '../models/UpdateCaseNoteRequest';
import type { UpdateCasePenaltyRequest } from '../models/UpdateCasePenaltyRequest';
import type { UpdateCaseRequest } from '../models/UpdateCaseRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CasesService {
  /**
   * List cases, filtering by various criteria.
   * @param query
   * @param status
   * @param assigneeId
   * @param typePrimaryId
   * @param operationTypeId
   * @param region
   * @param investigationStatus
   * @param carrierStatus
   * @param noticeOfViolationIssued
   * @param certificateNumber
   * @param noticeType
   * @param noddSent
   * @param finalOrderSent
   * @param attorneyId
   * @param noddLetterPrinted
   * @param finalOrderLetterPrinted
   * @param noddDueDatePassed
   * @param createdAt
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @param includeDeleted
   * @returns ListCasesResponse OK
   * @throws ApiError
   */
  public static listCases(
    query?: string,
    status?: Array<CaseStatus>,
    assigneeId?: Array<string>,
    typePrimaryId?: Array<number>,
    operationTypeId?: Array<number>,
    region?: Array<Region>,
    investigationStatus?: Array<CaseInvestigationStatus>,
    carrierStatus?: Array<CertificateStatus>,
    noticeOfViolationIssued?: boolean,
    certificateNumber?: string,
    noticeType?: Array<CaseNoticeType>,
    noddSent?: boolean,
    finalOrderSent?: boolean,
    attorneyId?: Array<string>,
    noddLetterPrinted?: Array<boolean>,
    finalOrderLetterPrinted?: Array<boolean>,
    noddDueDatePassed?: boolean,
    createdAt?: string,
    limit?: number,
    offset?: number,
    sortBy?: CaseSortBy,
    sortDirection?: SortDirection,
    format?: ExportFormat,
    includeDeleted?: boolean,
  ): CancelablePromise<ListCasesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases',
      query: {
        'query': query,
        'status': status,
        'assigneeId': assigneeId,
        'typePrimaryId': typePrimaryId,
        'operationTypeId': operationTypeId,
        'region': region,
        'investigationStatus': investigationStatus,
        'carrierStatus': carrierStatus,
        'noticeOfViolationIssued': noticeOfViolationIssued,
        'certificateNumber': certificateNumber,
        'noticeType': noticeType,
        'noddSent': noddSent,
        'finalOrderSent': finalOrderSent,
        'attorneyId': attorneyId,
        'noddLetterPrinted': noddLetterPrinted,
        'finalOrderLetterPrinted': finalOrderLetterPrinted,
        'noddDueDatePassed': noddDueDatePassed,
        'createdAt': createdAt,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
        'includeDeleted': includeDeleted,
      },
    });
  }
  /**
   * Get a single case by its id.
   * @param caseId
   * @returns GetCaseResponse OK
   * @throws ApiError
   */
  public static getCase(
    caseId: number,
  ): CancelablePromise<GetCaseResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}',
      path: {
        'caseId': caseId,
      },
    });
  }
  /**
   * Delete a single case by its id. NOTE: This is a soft delete.
   * @param caseId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static deleteCase(
    caseId: number,
    requestBody?: DeleteCaseRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Cases/{caseId}',
      path: {
        'caseId': caseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Update a case by its id.
   * @param caseId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateCase(
    caseId: number,
    requestBody?: UpdateCaseRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/{caseId}',
      path: {
        'caseId': caseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get the change history for a case by its id. Returns JSON by default, or CSV/PDF when format is specified.
   * @param caseId
   * @param format
   * @returns GetCaseHistoryResponse OK
   * @throws ApiError
   */
  public static getCaseHistory(
    caseId: number,
    format?: ExportFormat,
  ): CancelablePromise<GetCaseHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/history',
      path: {
        'caseId': caseId,
      },
      query: {
        'format': format,
      },
    });
  }
  /**
   * Assign a case to a business entity by their IDs.
   * @param caseId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static assignBusinessEntity(
    caseId: number,
    requestBody?: AssignBusinessEntityRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/{caseId}/business-entity',
      path: {
        'caseId': caseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Search same-company cases that could be recorded as this case's original (Delete Case dialog).
   * @param caseId
   * @param query
   * @returns SearchOriginalCaseCandidatesResponse OK
   * @throws ApiError
   */
  public static searchOriginalCaseCandidates(
    caseId: number,
    query?: string,
  ): CancelablePromise<SearchOriginalCaseCandidatesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/original-case-candidates',
      path: {
        'caseId': caseId,
      },
      query: {
        'query': query,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * Update a case investigation by its id.
   * @param caseId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateCaseInvestigation(
    caseId: number,
    requestBody?: UpdateCaseInvestigationRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/{caseId}/investigation',
      path: {
        'caseId': caseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Update a case penalty by its id.
   * @param caseId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateCasePenalty(
    caseId: number,
    requestBody?: UpdateCasePenaltyRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/{caseId}/penalty',
      path: {
        'caseId': caseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Delete a case's penalty and void any outstanding charge issued for it.
   * @param caseId
   * @returns void
   * @throws ApiError
   */
  public static deleteCasePenalty(
    caseId: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Cases/{caseId}/penalty',
      path: {
        'caseId': caseId,
      },
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Assign a letter type to one or more cases, then generate a batch PDF for printing
   * @param letterTypeCode
   * @param requestBody
   * @returns binary OK
   * @throws ApiError
   */
  public static generateCaseLetters(
    letterTypeCode: string,
    requestBody?: GenerateCaseLettersRequest,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Cases/letters/{letterTypeCode}',
      path: {
        'letterTypeCode': letterTypeCode,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * List all case types.
   * @returns ListCaseTypesResponse OK
   * @throws ApiError
   */
  public static listCaseTypes(): CancelablePromise<ListCaseTypesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/types',
    });
  }
  /**
   * List active case delete reasons.
   * @returns ListCaseDeleteReasonsResponse OK
   * @throws ApiError
   */
  public static listCaseDeleteReasons(): CancelablePromise<ListCaseDeleteReasonsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/delete-reasons',
    });
  }
  /**
   * List all case topics.
   * @returns ListCaseTopicsResponse OK
   * @throws ApiError
   */
  public static listCaseTopics(): CancelablePromise<ListCaseTopicsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/topics',
    });
  }
  /**
   * List all case complainant types.
   * @returns ListCaseComplainantTypesResponse OK
   * @throws ApiError
   */
  public static listCaseComplainantTypes(): CancelablePromise<ListCaseComplainantTypesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/complainant-types',
    });
  }
  /**
   * List all case letter types.
   * @returns ListCaseLetterTypesResponse OK
   * @throws ApiError
   */
  public static listCaseLetterTypes(): CancelablePromise<ListCaseLetterTypesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/letter-types',
    });
  }
  /**
   * Create a case note for a case by its id.
   * @param caseId
   * @param requestBody
   * @returns CreateCaseNoteResponse Created
   * @throws ApiError
   */
  public static createCaseNote(
    caseId: number,
    requestBody?: CreateCaseNoteRequest,
  ): CancelablePromise<CreateCaseNoteResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Cases/{caseId}/notes',
      path: {
        'caseId': caseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Create a case note for a case by its id.
   * @param caseId
   * @returns ListCaseNotesResponse OK
   * @throws ApiError
   */
  public static listCaseNotes(
    caseId: number,
  ): CancelablePromise<ListCaseNotesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/notes',
      path: {
        'caseId': caseId,
      },
    });
  }
  /**
   * Update a case note by its id.
   * @param noteId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static updateCaseNote(
    noteId: number,
    requestBody?: UpdateCaseNoteRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/notes/{noteId}',
      path: {
        'noteId': noteId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Delete a case note by its id.
   * @param noteId
   * @returns void
   * @throws ApiError
   */
  public static deleteCaseNote(
    noteId: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Cases/notes/{noteId}',
      path: {
        'noteId': noteId,
      },
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * List all violations, filtered by an optional query string.
   * @param query
   * @param limit
   * @param offset
   * @returns ListCaseViolationsResponse OK
   * @throws ApiError
   */
  public static searchCaseViolations(
    query?: string,
    limit?: number,
    offset?: number,
  ): CancelablePromise<ListCaseViolationsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/violations',
      query: {
        'query': query,
        'limit': limit,
        'offset': offset,
      },
    });
  }
  /**
   * List all violations associated with a case by its id.
   * @param caseId
   * @returns ListCaseViolationsResponse OK
   * @throws ApiError
   */
  public static listCaseViolations(
    caseId: number,
  ): CancelablePromise<ListCaseViolationsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/violations',
      path: {
        'caseId': caseId,
      },
    });
  }
  /**
   * Add a violation to a case by their ids.
   * @param caseId
   * @param violationId
   * @returns void
   * @throws ApiError
   */
  public static addCaseViolation(
    caseId: number,
    violationId: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/{caseId}/violations/{violationId}',
      path: {
        'caseId': caseId,
        'violationId': violationId,
      },
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Remove a violation from a case by their ids.
   * @param caseId
   * @param violationId
   * @returns void
   * @throws ApiError
   */
  public static removeCaseViolation(
    caseId: number,
    violationId: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Cases/{caseId}/violations/{violationId}',
      path: {
        'caseId': caseId,
        'violationId': violationId,
      },
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * List all affiliations associated with a case by its id.
   * @param caseId
   * @returns ListCaseAffiliationsResponse OK
   * @throws ApiError
   */
  public static listCaseAffiliations(
    caseId: number,
  ): CancelablePromise<ListCaseAffiliationsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/affiliations',
      path: {
        'caseId': caseId,
      },
    });
  }
  /**
   * Add a carrier affiliation to a case by their ids.
   * @param caseId
   * @param businessEntityId
   * @returns void
   * @throws ApiError
   */
  public static addCaseAffiliation(
    caseId: number,
    businessEntityId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Cases/{caseId}/affiliations/{businessEntityId}',
      path: {
        'caseId': caseId,
        'businessEntityId': businessEntityId,
      },
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Remove a business entity affiliation from a case by their ids.
   * @param caseId
   * @param businessEntityId
   * @returns void
   * @throws ApiError
   */
  public static removeCaseAffiliation(
    caseId: number,
    businessEntityId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Cases/{caseId}/affiliations/{businessEntityId}',
      path: {
        'caseId': caseId,
        'businessEntityId': businessEntityId,
      },
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * List attachments for a case by id and section.
   * @param caseId
   * @param section
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static listCaseAttachments(
    caseId: number,
    section: CaseSection,
  ): CancelablePromise<Array<StoredDocument>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/attachments/{section}',
      path: {
        'caseId': caseId,
        'section': section,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Upload an attachment for a case by id and section.
   * @param caseId
   * @param section
   * @param formData
   * @returns StoredDocument OK
   * @throws ApiError
   */
  public static uploadCaseAttachment(
    caseId: number,
    section: CaseSection,
    formData?: {
      file?: Blob;
    },
  ): CancelablePromise<StoredDocument> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Cases/{caseId}/attachments/{section}',
      path: {
        'caseId': caseId,
        'section': section,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Delete a case attachment by section and file name.
   * @param caseId
   * @param section
   * @param name
   * @returns void
   * @throws ApiError
   */
  public static deleteCaseAttachment(
    caseId: number,
    section: CaseSection,
    name?: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Cases/{caseId}/attachments/{section}',
      path: {
        'caseId': caseId,
        'section': section,
      },
      query: {
        'name': name,
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Download or preview a case attachment by section and file name.
   * @param caseId
   * @param section
   * @param name
   * @param download
   * @returns any OK
   * @throws ApiError
   */
  public static downloadCaseAttachment(
    caseId: number,
    section: CaseSection,
    name?: string,
    download: boolean = false,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Cases/{caseId}/attachments/{section}/content',
      path: {
        'caseId': caseId,
        'section': section,
      },
      query: {
        'name': name,
        'download': download,
      },
    });
  }
}
